// extracted by mini-css-extract-plugin
export default {"tag":"style_tag__hjOB1","placeholder":"style_placeholder__cKL3e","select":"style_select__vrzvN","menu":"style_menu__0QTj3"};